import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "7d70f6e1-d2c1-487c-afff-44d8a3fe173a",
  solutionType: "custom010600",
  type: "custom010600",
  options: {},
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom010600",
  data: [
    {
      sourceId: "S1",
      targetId: "T3",
    },
    {
      sourceId: "S7",
      targetId: "T6",
    },
  ],
};
